import axios from 'axios'
import ENDPOINTS from './../api/constant/index'
import PAGES_LINKS from './../pages/constants/index'
import { defaultLanguage } from './../translations/constant/index'
import { addTheLogOutBehavior } from './axios'
import CONSTANTS from './constants'
import { decrypt, encrypt } from './security'
import { deleteCookie, getCookieValue, setCookie } from './utils'
import { _ } from 'core-js'

const renewObject = {
  isRefreshing: false,
  failedQueue: [],
  processQueue: function (error, token = null) {
    this.failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error)
      } else {
        prom.resolve(token)
      }
    })
    this.reset()
  },
  reset: function () {
    this.isRefreshing = false
    this.failedQueue = []
  },
}

const api = '/api/'
const axiosCorporateInstance = axios.create({
  baseURL: `${process.env.REACT_APP_CORPORATE_URL}${api}`,
})
const authenticatedCorporateAxios = axios.create({
  baseURL: `${process.env.REACT_APP_CORPORATE_URL}${api}`,
})

const customerCode = JSON.parse(localStorage.getItem('customerCode'))

const refreshCorporateAccessToken = async () => {
  let clickedLogin = localStorage.getItem('clickedLogin')

  const { data: tokens } = await authenticatedCorporateAxios.post(
    `${ENDPOINTS.corporateLogInfo.root}${ENDPOINTS.corporateLogInfo.renew}`,
    {
      appVersion: '0',
      osType: '0',
    }
  )
  if (tokens?.result?.token) {
    setCookie({
      cname: 'token',
      cvalue: encrypt(tokens.result.token),
      expires: 30,
      cookieExpireTimeType: CONSTANTS.DAYS,
    })
    setCookie({
      cname: 'refreshToken',
      cvalue: encrypt(tokens.result.refreshToken),
      expires: 30,
      cookieExpireTimeType: CONSTANTS.DAYS,
    })
    if (customerCode) {
      setCookie({
        cname: 'customer-code-token',
        cvalue: encrypt(tokens.result.corpToken),
        expires: 30,
        cookieExpireTimeType: CONSTANTS.DAYS,
      })
    } else {
      if (clickedLogin === 'Paltel') {
        setCookie({
          cname: 'paltel-corp-token',
          cvalue: encrypt(tokens.result.corpToken),
          expires: 30,
          cookieExpireTimeType: CONSTANTS.DAYS,
        })
      } else  {
        setCookie({
          cname: 'corp-token',
          cvalue: encrypt(tokens.result.corpToken),
          expires: 30,
          cookieExpireTimeType: CONSTANTS.DAYS,
        })
      } 
    }

    checkIsUserSavedCorporatePassword(tokens.result.corpToken)
  }
  return tokens
}
export const isPasswordSaved = (type) => {
  if (customerCode) {
    let mobileNum = getCookieValue('customerCodeToken').split(' ')[0]
    return mobileNum === localStorage.getItem('mainNumber')
  } else {
    if (type == 'Paltel') {
      let mobileNum = getCookieValue('paltelToken').split(' ')[0]
      return mobileNum === localStorage.getItem('mainNumber')
    } else if (type == 'Jawwal') {
      let mobileNum = getCookieValue('corpToken').split(' ')[0]
      return mobileNum === localStorage.getItem('mainNumber')
    }
  }
}
const corporateLogout = () => {
  let clickedLogin = localStorage.getItem('clickedLogin')
  if (customerCode) {
    if (isPasswordSaved(clickedLogin)) {
      deleteCookie('customerCodeToken')
      deleteCookie('rememberCustomerCodeToken')
    } else {
      addTheLogOutBehavior()
    }
    deleteCookie('customer-code-token')
    deleteCookie('token')
    deleteCookie('refreshToken')
    deleteCookie('switchToken')
  } else {
    if (clickedLogin === 'Paltel') {
      if (isPasswordSaved(clickedLogin)) {
        deleteCookie('paltelToken')
      }
    } else if (clickedLogin === 'Jawwal') {
      if (isPasswordSaved(clickedLogin)) {
        deleteCookie('corpToken')
      }
    }
    deleteCookie('corp-token')
    deleteCookie('paltel-corp-token')
  }
}
const checkIsUserSavedCorporatePassword = (corporateToken) => {
  let clickedLogin = localStorage.getItem('clickedLogin')
  if (customerCode) {
    let mobileNum = getCookieValue('customerCodeToken').split(' ')[0]
    if (isPasswordSaved(clickedLogin)) {
      setCookie({
        cname: 'customerCodeToken',
        cvalue: `${mobileNum} ${corporateToken}`,
        expires: 30,
        cookieExpireTimeType: CONSTANTS.DAYS,
      })
    }
  } else {
    if (clickedLogin == 'Paltel') {
      let mobileNum = getCookieValue('paltelToken').split(' ')[0]
      if (isPasswordSaved(clickedLogin)) {
        setCookie({
          cname: 'paltelToken',
          cvalue: `${mobileNum} ${corporateToken}`,
          expires: 30,
          cookieExpireTimeType: CONSTANTS.DAYS,
        })
      }
    } else if (clickedLogin == 'Jawwal') {
      let mobileNum = getCookieValue('corpToken').split(' ')[0]
      if (isPasswordSaved(clickedLogin)) {
        setCookie({
          cname: 'corpToken',
          cvalue: `${mobileNum} ${corporateToken}`,
          expires: 30,
          cookieExpireTimeType: CONSTANTS.DAYS,
        })
      }
    }
  }
}
axiosCorporateInstance.interceptors.request.use(async (config) => {
  let clickedLogin = localStorage.getItem('clickedLogin')
  let clickedCookieValue
  if (customerCode) {
    clickedCookieValue = decrypt(getCookieValue('customer-code-token'))
  } else {
    if (clickedLogin === 'Paltel') {
      clickedCookieValue = decrypt(getCookieValue('paltel-corp-token'))
    } else if (clickedLogin === 'Jawwal') {
      clickedCookieValue = decrypt(getCookieValue('corp-token'))
    }
  }

  config.headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${clickedCookieValue}`,
    'individual-token': decrypt(getCookieValue('token')),
    Lang: !!localStorage.getItem('lang')
      ? localStorage.getItem('lang')
      : defaultLanguage,
    Channel: 'Website',
  }
  if (config.method === 'post') {
    config.data = {
      ...(typeof config.data === 'string'
        ? JSON.parse(config.data)
        : config.data),
      deviceId: localStorage.getItem('deviceId'),
    }
  }
  if (
    config.url ===
    `${ENDPOINTS.corporateLogInfo.root}${ENDPOINTS.corporateLogInfo.renew}`
  ) {
    config.headers = {
      ...config.headers,
      'Refresh-Token': decrypt(getCookieValue('refreshToken')),
    }
    config._renewRequest = true
  }
  return config
})

authenticatedCorporateAxios.interceptors.request.use(async (config) => {
  let clickedLogin = localStorage.getItem('clickedLogin')
  const token = decrypt(getCookieValue('token'))
  const corporateToken = decrypt(getCookieValue('corp-token'))
  const paltelCorporateToken = decrypt(getCookieValue('paltel-corp-token'))
  const cutomerCodeCorporateToken = decrypt(
    getCookieValue('customer-code-token')
  )

  let cookie
  if (customerCode) {
    cookie = cutomerCodeCorporateToken
  } else {
    if (clickedLogin === 'Paltel') {
      cookie = paltelCorporateToken
    } else if (clickedLogin === 'Jawwal') {
      cookie = corporateToken
    }
  }
  if (!token) {
    throw new authenticatedCorporateAxios.Cancel(
      'Operation canceled by the user.'
    )
  }
  config.headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${cookie}`,
    'individual-token': token,
    Lang: !!localStorage.getItem('lang')
      ? localStorage.getItem('lang')
      : defaultLanguage,
    Channel: 'Website',
  }
  if (config.method === 'post') {
    config.data = {
      ...(typeof config.data === 'string'
        ? JSON.parse(config.data)
        : config.data),
      deviceId: localStorage.getItem('deviceId'),
    }
  }
  if (
    config.url ===
    `${ENDPOINTS.corporateLogInfo.root}${ENDPOINTS.corporateLogInfo.renew}`
  ) {
    config.headers = {
      ...config.headers,
      'Refresh-Token': decrypt(getCookieValue('refreshToken')),
    }
    config._renewRequest = true
  }
  return config
})

authenticatedCorporateAxios.interceptors.response.use(
  (response) => {
    return response
  },
  async function (error) {
    const originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) {
      if (originalRequest._renewRequest) {
        renewObject.processQueue(null)
        corporateLogout()
        return window.location.assign(
          `/#${PAGES_LINKS.more.root}?isCorporateSessionEnd=true`
        )
      }
      if (renewObject.isRefreshing) {
        return new Promise(function (resolve, reject) {
          renewObject.failedQueue.push({ resolve, reject })
        })
          .then(() => {
            return authenticatedCorporateAxios(originalRequest)
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      renewObject.isRefreshing = true

      const tokens = await refreshCorporateAccessToken()
      if (tokens?.result?.token) {
        authenticatedCorporateAxios.defaults.headers[
          'Authorization'
        ] = `Bearer ${tokens.result.corpToken}`
        authenticatedCorporateAxios.defaults.headers['individual-token'] =
          tokens.result.token
        originalRequest.headers[
          'Authorization'
        ] = `Bearer ${tokens.result.corpToken}`
        originalRequest.headers['individual-token'] = tokens.result.token
        renewObject.processQueue(null, tokens.result.corpToken)
        return authenticatedCorporateAxios(originalRequest)
      } else {
        renewObject.processQueue(null)
        corporateLogout()
        return window.location.assign(
          `/#${PAGES_LINKS.more.root}?isCorporateSessionEnd=true`
        )
      }
    }
    if (error.response.status === 403 && !originalRequest._retry) {
      addTheLogOutBehavior()
    }
    return Promise.reject(error)
  }
)

export {
  axiosCorporateInstance,
  authenticatedCorporateAxios,
  corporateLogout,
  refreshCorporateAccessToken,
  renewObject,
}
// eslint-disable-next-line prettier/prettier
